import { render, staticRenderFns } from "./BaseLabel.vue?vue&type=template&id=596a90a0&scoped=true&"
import script from "./BaseLabel.js?vue&type=script&lang=js&"
export * from "./BaseLabel.js?vue&type=script&lang=js&"
import style0 from "./BaseLabel.scss?vue&type=style&index=0&id=596a90a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596a90a0",
  null
  
)

/* custom blocks */
import block0 from "./BaseLabel.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fcomponents%2Fcommon%2Fform%2FBaseLabel%2FBaseLabel.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports